var exports = {
  "de": "PopoverContainer__hFfyQd",
  "hl": "PopoverContent__ZoBYij",
  "DZ": "Heading__e_XIH-",
};

module.exports = exports;
